module.exports = __webpack_public_path__ + "media/images/about_solution-pic5-fd7f86ed.png";